var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:([_vm.scroll > 380 ? { display: 'block' } : '']),attrs:{"id":"gotoTop","title":"Go to top"},on:{"click":_vm.topFunction}})
}
var staticRenderFns = []

export { render, staticRenderFns }